<template>
  <div class="wapgjxx-view-static" id="app">
    <TopHeaderSearch />
    <TopHeader />
    <TopNav />
    <TopSubstation />
    <h1 class="wapgjxx-title">{{ listObj.title }}</h1>
    <PickerAddress />
    <List />
    <div class="key_tit">
      <span>&nbsp;&nbsp;&nbsp;&nbsp;当前位置：</span><a href="//wap.qianlima.com" target="_blank">千里马首页</a>
      <a v-if="listObj.areaId && listObj.areaId !== '2703'" :href="`/zb/area_${listObj.areaId}/`"
        >&gt;{{ listObj.areaName }}招标网</a
      >&gt; <a>{{ listObj.title }}</a>
    </div>
    <footer class="footer-box">
      <p class="go-top">
        <a id="dial2" href="tel:400-688-2000">咨询热线<span style="margin-left: 10px">400-688-2000</span></a>
      </p>
      <div class="more-btn">
        <a href="//wap.qianlima.com/">首页</a>
        <a href="//wap.qianlima.com/common/sitemap.html">网站地图</a>
        <a href="//wap.qianlima.com/xxwm.html" target="_self">联系我们</a>
      </div>
      <p class="copyright"><a>版权所有-千里马招标网</a></p>
    </footer>
    <FixedBottom />
    <div id="backToTop" @click="backTop" v-if="backTopShow">
      <i class="scrollup"></i>
    </div>
  </div>
</template>

<script>
import { getLoginStatus } from "@/utils/common";
import TopHeaderSearch from "@/components/wapGjxx/TopHeaderSearch";
import TopHeader from "@/components/wapGjxx/TopHeader";
import TopNav from "@/components/wapGjxx/TopNav";
import TopSubstation from "@/components/wapGjxx/TopSubstation";
import PickerAddress from "@/components/wapGjxx/PickerAddress";
import FixedBottom from "@/components/wapGjxx/FixedBottom";
import List from "@/components/wapGjxx/List";
import { userApiMemberSingleFindUserContent } from "@/services/gjxx";
export default {
  name: "wapGjxx",
  components: {
    TopHeaderSearch,
    TopHeader,
    TopNav,
    TopSubstation,
    PickerAddress,
    FixedBottom,
    List,
  },
  data() {
    return {
      username: "",
      isLoginStatus: false,
      backTopShow: false,
    };
  },
  computed: {
    listObj() {
      return this.$store.getters["wapGjxx/listObj"];
    },
  },
  created() {},
  mounted() {
    this.isLoginStatus = getLoginStatus();
    if (this.isLoginStatus) {
      this.getUser();
    }
    document.addEventListener("scroll", this.scrollWor);
  },
  methods: {
    scrollWor() {
      const scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const scrollTop = 200;
      if (scrollHeight > scrollTop) {
        this.backTopShow = true;
      } else {
        this.backTopShow = false;
      }
    },

    async getUser() {
      const userInfo = await userApiMemberSingleFindUserContent().then((res) => res.data);
      this.$store.commit("wapGjxx/updateUserInfo", userInfo);
    },
    backTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scrollWor);
  },
};
</script>

<style lang="scss">
.wapgjxx-view-static {
  // background: #fff;
  color: #000;
  width: 100vw;
  max-width: 750px;
  padding-top: 50px;
  font-size: 14px;
  margin: 0 auto;
  .wapgjxx-title {
    height: 40px;
    line-height: 40px;
    margin-top: 10px;
    padding: 0 10px;
    background: #fff;
    border-bottom: 1px solid #d7d7d7;
    position: relative;
    padding-left: 26px;
    color: #e60012;
    font-size: 14px;
    font-weight: normal;
    &::after {
      content: "";
      width: 4px;
      height: 14px;
      background: #e60012;
      vertical-align: middle;
      position: absolute;
      top: 13px;
      left: 9px;
    }
  }
  #backToTop {
    position: fixed;
    z-index: 22;
    text-align: center;
    bottom: 144px;
    right: 16px;
    overflow: hidden;
    width: 40px;
    height: 40px;
    // display: none;
  }
  .scrollup {
    display: inline-block;
    width: 40px;
    height: 40px;
    background: url(//gw-static.qianlima.com/0cdn/static/front/qlmBidding_static_template/img/wap/gglb_huidaodingbu.png)
      no-repeat 0 0;
    background-size: 40px 40px;
  }
  .key_tit {
    background-color: #fff;
    margin-bottom: -10px;
    font-size: 12px;

    a {
      color: #333;
    }
  }
  .footer-box {
    padding: 16px 28px 58px;
    margin-top: 8px;
    background: #e60012;
    text-align: center;
    a {
      color: #fff;
    }
    .go-top {
      font-size: 16px;
    }
    .more-btn {
      overflow: hidden;
      display: flex;
      justify-content: space-around;
      align-items: center;
    }
    .copyright {
      font-size: 10px;
    }
  }
}
</style>
